import { action, computed, observable } from 'mobx';
import { Location, createBrowserHistory } from 'history';

import {  SignalRMethods } from '@app/AppConstants/SignalR';
import { signalRService } from '@app/Services/SignalRService';

import { personActivityStore } from './PersonActivityStore';
import { applyDecorators } from '@app/Helpers/Decorator';

export const history = createBrowserHistory();

class NavigationStore {
    @observable public currentLocation: Location;

    constructor() {
        this.currentLocation = Object.create(history.location);
        applyDecorators(this);
    }

    @action
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this._sendCurrentLocation();
        });

        history.listen((location: Location) => {
            this.currentLocation = location;

            this._sendCurrentLocation();
        });

        const target = document.querySelector('title');
        let lastTitle = document.title;
        const observer = new MutationObserver(() => {
            //remove file changes detected title changes in asp.net browser refresh
            const newTitle = document.title.replace(/[☱,☲,☴]/, '');
            if (newTitle !== lastTitle){
                lastTitle = newTitle;
                this._sendCurrentLocation();
            }
        });
        const config = {
            childList: true,
        };
        target && observer.observe(target, config);

        signalRService.addReconnectObserver(this._onSignalRReconnect);
    }

    private _sendCurrentLocation() {
        signalRService.sendNotification(SignalRMethods.updatePersonLocation, { location: this.currentLocation.pathname, locationName: document.title });
        personActivityStore.updatePersonLastActivity();
    }

    private _onSignalRReconnect() {
        const location = Object.create(history.location);

        signalRService.sendNotification(SignalRMethods.updatePersonLocation, { location: location.pathname, locationName: document.title });
        personActivityStore.sendPersonLastActivity();
    }

    //NAVIGATION
    @action
    redirect<T>(url: string, isCtrlKey: boolean = false, state?: T) {
        if (isCtrlKey) {
            const target = '_blank';
            const win = window.open(url, target);
            win && win.focus();
            return;
        }

        if (state) {
            history.push(url, state);
        } else {
            if(url.charAt(0) === '/') {
                history.push(url);
            } else {
                window.location.href = url;
            }
        }
    }

    replace<T>(url: string, state?: T) {
        if (state) {
            history.replace(url, state);
        } else {
            history.replace(url);
        }
    }

    @computed
    get isHomePage() {
        const regExp = /^\/$/;
        return !this.currentLocation || regExp.test(this.currentLocation.pathname);
    }

    @computed
    get isRequestTool() {
        const regExpExclude = /^\/request-tool-configuration/;
        return !this.currentLocation || ((/^\/request-tool/.test(this.currentLocation.pathname) || /^\/crew-portal/.test(this.currentLocation.pathname)) && !regExpExclude.test(this.currentLocation.pathname));
    }
}

export const navigationStore = new NavigationStore();
